'use client'

import React from 'react';
import styled from 'styled-components';
import {usePathname} from "next/navigation";
import Link from "next/link";
import {hover, Transition} from "@/styles/globalStyleVars";
import parser from "html-react-parser";

const StickyButton = ({link, img, svg, text}) => {

    const location = usePathname();

    return (
        <StyledBtn className={`dc-btn`}
        >
            <Link id="imSticky" data-magnetism target={'_blank'} href={link ? `https://wa.me/${link}` : 'https://wa.me/+8801733086507'}>
                {
                    svg ?
                        parser(svg)
                        :
                        img ?
                            <img src={img} alt={text}/>
                            : ''
                }

            </Link>
        </StyledBtn>
    )
};

const StyledBtn = styled.div`

    position: fixed;
    right: 50px;
    bottom: 30px;
    z-index: 999;

    @media(max-width: 767px){
        right: 15px;
        bottom: 15px;
    }
    a {
        .circle {
            transition: 0.7s all ${Transition};
        }

        &:hover {
            .circle{
                r: 25px;
            }
        }
    }
`;


export default React.memo(StickyButton);
